// extracted by mini-css-extract-plugin
module.exports = {"todosContainer":"TodoContainer_todosContainer__2nYVb","todoHeader":"TodoContainer_todoHeader__3N4_f"};